import React, { useState, useEffect, useRef } from "react";
import {
  Nav,
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Alert,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  query,
  where,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import "./style/Rating.css";
import { db } from "../firebase";
import LogoIcon from "./assets/img/logo-main.png";

export default function Rating() {
  const [currentUserDetails, setCurrentUserDetails] = useState();
  const [currentUserStored, setCurrentUserStored] = useState();
  const [name, setName] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("All");
  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const merchantId = currentUser.uid;
  const [facilities, setFacilities] = useState([]);
  const [selectedRatingDetails, setSelectedRatingDetails] = useState();
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  let unsubscribe;
  document.title ='Rating - Hentian Komuniti';

  useEffect(() => {
    const storedUser = sessionStorage.getItem("currentUserDetail");
    if (storedUser) {
      if (!currentUserDetails) {
        setCurrentUserDetails(JSON.parse(storedUser));
        setName(JSON.parse(storedUser).name);
      }
    } else {
      console.log("No user found in session storage");
    }
  }, [currentUserDetails, setCurrentUserDetails]);

  useEffect(() => {
    const user = sessionStorage.getItem("currentUser");
    if (user) {
      if (!currentUserStored) {
        setCurrentUserStored(JSON.parse(user));
      }
    } else {
      console.log("No user found in session storage");
    }
  }, [currentUserStored, setCurrentUserStored]);

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        if (merchantId) {
          const q = query(
            collection(db, "facility"),
            where("merchant_id", "==", merchantId)
          );
          const querySnapshot = await getDocs(q);
          const data = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          const facilitiesWithRatings = await Promise.all(
            data.map(async (facility) => {
              const ratingQuery = query(
                collection(db, "rating"),
                where("facilityID", "==", facility.id)
              );
              const ratingSnapshot = await getDocs(ratingQuery);
              const ratingsData = ratingSnapshot.docs.map((ratingDoc) =>
                ratingDoc.data()
              );
              const ratingInfo = { ratings: ratingsData }; // Adjust this based on your rating structure
              console.log("hello", facility);
              return { ...facility, ...ratingInfo };
            })
          );

          // Check if the fetched data is different before updating the state
          const areFacilitiesDifferent =
            JSON.stringify(facilitiesWithRatings) !==
            JSON.stringify(facilities);
          if (areFacilitiesDifferent) {
            console.log(
              "Updating facilities with ratings:",
              facilitiesWithRatings
            );
            setFacilities(facilitiesWithRatings);
          }

          // // Set up a real-time listener for changes
          // unsubscribe = onSnapshot(q, (snapshot) => {
          //   const updatedData = snapshot.docs.map((doc) => ({
          //     id: doc.id,
          //     ...doc.data(),
          //   }));
          //   console.log('Updating the facility list', snapshot)
          //   setFacilities(updatedData);
          // });
        }
      } catch (error) {
        console.error("Error fetching facilities: ", error);
      }
    };

    fetchFacilities();

    return () => {
      // Unsubscribe from the listener when component unmounts
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [merchantId]);

  const handleFilterChange = (e) => {
    setFilterValue(e.target.value);
  };

  const handleFilterSelect = (filter) => {
    setSelectedFilter(filter);
    setFilterValue("");
  };

  const showRatingDetails = (rating) => {
    setSelectedRatingDetails(rating);
    setShowModal(true);
  };

  const filterRatings = () => {
    if (selectedFilter === "All") {
      return facilities.flatMap((facility) =>
        facility.ratings.map((rating) => ({
          facilityName: facility.facilityName,
          type: facility.type,
          rating: rating.rating,
          comment: rating.comment,
          rateDateTime: rating.rateDateTime,
        }))
      );
    } else {
      const selectedFacility = facilities.find(
        (facility) => facility.facilityName === selectedFilter
      );
      if (selectedFacility) {
        return selectedFacility.ratings.map((rating) => ({
          facilityName: selectedFacility.facilityName,
          type: selectedFacility.type,
          rating: rating.rating,
          comment: rating.comment,
          rateDateTime: rating.rateDateTime,
        }));
      } else {
        return [];
      }
    }
  };

  const ratingsPerPage = 10;
  const indexOfLastRating = currentPage * ratingsPerPage;
  const indexOfFirstRating = indexOfLastRating - ratingsPerPage;
  const currentRatings = filterRatings().slice(
    indexOfFirstRating,
    indexOfLastRating
  );

  const totalPages = Math.ceil(filterRatings().length / ratingsPerPage);
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  console.log("saikdhasd", totalPages)

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  //TODO : make the rating viewable

  return (
    <div>
      <div className="mt-2 ms-4">
        <h3 className="company-name">
        <span className="">
              <img src={LogoIcon} className="me-2 logo-merchant"></img>
            </span>
            {currentUserDetails && currentUserDetails.name}
        </h3>
      </div>
      <hr id="line" className="text-secondary"></hr>
      <div className="">
        <Row className="d-flex justify-content-between">
          <Col xs="auto" className="ms-4 pb-3">
            <i className="bi bi-list-stars fs-3"></i>
            <span className="fs-5 ms-2">List of Rating</span>
          </Col>
          <Col xs="auto" className="ms-3 me-sm-5">
            <DropdownButton
              id="dropdown-button"
              title={`Filter By ${selectedFilter}`}
            >
              <Dropdown.Item
                className="filter-item"
                onClick={() => handleFilterSelect("All")}
              >
                All
              </Dropdown.Item>
              {facilities.map((facility) => (
                <Dropdown.Item
                  className="filter-item"
                  onClick={() => handleFilterSelect(facility.facilityName)}
                >
                  {facility.facilityName}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </Col>
        </Row>
      </div>
      <div className="table-responsive mx-5 my-1 mt-3 mt-sm-2">
        <table className="table">
          <thead>
            <tr className="custom-trow">
              <th className="custom-thead">Facility</th>
              <th className="custom-thead">Type</th>
              <th className="custom-thead">Rating</th>
              <th className="custom-thead">Comment</th>
              <th className="custom-thead">Time</th>
              <th className="custom-thead">Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRatings.map((rating, index) => (
              <tr className="custom-trow" key={`filtered-${index}`}>
                <td className="facility-column" data-label="Facility">
                  {rating.facilityName}
                </td>
                <td className="type-column" data-label="Type">
                  {rating.type}
                </td>
                <td className="rating-column" data-label="Rating">
                  {rating.rating}
                </td>
                <td className="comment-column" data-label="Comment">
                  {rating.comment}
                </td>
                <td className="time-column" data-label="Time">
                  {rating.rateDateTime &&
                    new Date(
                      rating.rateDateTime.seconds * 1000
                    ).toLocaleString()}
                </td>
                <td className="action-column">
                  <Button
                    className="viewBtn"
                    onClick={() => showRatingDetails(rating)}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="d-flex justify-content-end align-items-center mt-3">
          <div className="justify-content-center">
            <h6 className="me-3" style={{ color: "grey", fontSize: "15px" }}>
              {currentPage} of {totalPages > 0 ? totalPages : 1} pages
            </h6>
          </div>
          <button
            className="btn custom-button me-2"
            onClick={prevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button
            className="btn custom-button "
            onClick={nextPage}
            disabled={currentPage === totalPages || totalPages==0}
          >
            Next
          </button>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Rating Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display selected facility details */}
          {selectedRatingDetails && (
            <div>
              <p>
                <strong>Facility Name:</strong> {selectedRatingDetails.facilityName}
              </p>
              <p>
                <strong>Type:</strong> {selectedRatingDetails.type}
              </p>
              <p>
                <strong>Rating:</strong> {selectedRatingDetails.rating}
              </p>
              <p className="comment">
                <strong>Comment:</strong>{" "}
                <span className="comment-text">
                  {selectedRatingDetails.comment}
                </span>
              </p>
              <p>
                <strong>Time:</strong>{" "}
                {selectedRatingDetails.rateDateTime &&
                  new Date(
                    selectedRatingDetails.rateDateTime.seconds * 1000
                  ).toLocaleString()}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button id="custom-button" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
